'use client'

import { Session } from 'next-auth'
import { useEffect } from 'react'
import useWebSocket from 'react-use-websocket'
import { useShallow } from 'zustand/react/shallow'

import { NotificationTypes } from '@/lib/generated-enums'

import { useNotificationStore } from './notification-store'
import Notifications from './Notifications'

interface WebSocketMessage {
  type: NotificationTypes
  is_read: boolean
}
interface InitialWebSocketMessage {
  message: string
  user_id: number
}

export default function NotificationWrapper({ session }: { session?: Session }) {
  // const hasNotification = useNotificationStore(
  //   useShallow((state) => Object.values(state.data).some((value) => value === true))
  // )
  const [notifications, setNotifications] = useNotificationStore(useShallow((state) => [state.data, state.add]))

  const { lastJsonMessage, sendJsonMessage } = useWebSocket<WebSocketMessage | InitialWebSocketMessage>(
    'wss://server.gowello.co.uk/ws/notifications/',
    {
      onOpen: () => {
        sendJsonMessage({ token: session?.access_token }, true)
      },
      onClose: () => console.log('closed'),
      onError: (error) => console.error('error', error),
      shouldReconnect: () => true,
    }
  )

  console.log(lastJsonMessage, notifications)

  useEffect(() => {
    if (lastJsonMessage !== null) {
      if ('message' in lastJsonMessage) {
        return
      }
      const { type, is_read } = lastJsonMessage
      setNotifications(type, is_read)
    }
  }, [lastJsonMessage, setNotifications])

  return (
    <>
      <Notifications />
      {/* {hasNotification && (
        <div
          className={`absolute right-0 top-0 h-3 w-3 rounded-full bg-red-500`}
        />
      )} */}
    </>
  )
}
